import React, { useState } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import RadioGroup from '../../../../../ui-kitchen/src/components/RadioGroup';
import Radio from '../../../../../ui-kitchen/src/components/Radio';

const MultipleChoice = ({
  questionId,
  questionsetId,
  answerQuestion,
  options,
}) => {
  const [isChecked, setIsChecked] = useState();
  return (
    <RadioGroup
      onChange={(val) => {
        answerQuestion(questionsetId, questionId, val, null);
        setIsChecked(val);
      }}
      className="MultipleChoiceButtons"
      aria-labelledby="checkedOption"
      data-test-id="multiple-choice"
    >
      {options.map((option) => (
        <Radio
          id="checkedOption"
          key={option.id}
          className={cx('MultipleChoiceButton', { selected: isChecked === option.id })}
          checked={isChecked === option.id}
          value={option.id}
          variant="input"
        >
          <span>{option.text}</span>
        </Radio>
      ))}
    </RadioGroup>
  );
};

MultipleChoice.propTypes = {
  questionId: PropTypes.number,
  questionsetId: PropTypes.number,
  answerQuestion: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.number,
      order: PropTypes.number,
    })
  ),
};

MultipleChoice.defaultProps = {
  questionId: null,
  questionsetId: null,
  answerQuestion: () => { },
  options: [],
};

MultipleChoice.displayName = 'MultipleChoice';
export default MultipleChoice;
